var map = {
	"./arg.svg": 934,
	"./aus.svg": 935,
	"./bel.svg": 936,
	"./bra.svg": 937,
	"./can.svg": 938,
	"./cmr.svg": 939,
	"./crc.svg": 940,
	"./cro.svg": 941,
	"./den.svg": 942,
	"./ecu.svg": 943,
	"./eng.svg": 944,
	"./esp.svg": 945,
	"./fra.svg": 946,
	"./ger.svg": 947,
	"./gha.svg": 948,
	"./irn.svg": 949,
	"./jpn.svg": 950,
	"./kor.svg": 951,
	"./ksa.svg": 952,
	"./mar.svg": 953,
	"./mex.svg": 954,
	"./ned.svg": 955,
	"./pol.svg": 956,
	"./por.svg": 957,
	"./qat.svg": 958,
	"./sen.svg": 959,
	"./srb.svg": 960,
	"./sui.svg": 961,
	"./tun.svg": 962,
	"./uru.svg": 963,
	"./usa.svg": 964,
	"./wal.svg": 965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;